
export const getAPIURL = () => {
    // const apiUrl = 'http://api.acv.bblabz.com/';
    // const apiUrl = 'http://api.scm.bblabz.com/';
    // const apiUrl = 'http://api.sks.bblabz.com/';
    // const apiUrl = 'http://api.tmt.bblabz.com/';
    // const apiUrl = 'http://api.tmt-dev.bblabz.com/';

    const apiUrl = 'https://api.sks.milleasy.com/';

    return apiUrl;
}

// getLicenseKey
export const getLicenseKey = 5566;